export default __webpack_public_path__ + "static/media/carta_seleciona_01.15b1c197.mp3";